import type { FunctionComponent } from "react";

import { section } from "shared/data";
import { useEditionValue } from "shared/lib/edition";
import { useGetHomeAsPath } from "shared/lib/router";

import { page as HomePage } from "scmp-app/pages/home";

import {
  Container,
  Copyright,
  Footer,
  LogoCaption,
  LogoContainer,
  LogoPostMagazine,
  LogoSCMPContainer,
  LogoStyleContainer,
  SiteMapContainer,
  StyledPostMagazineSiteMap,
  StyledPostMagazineSocialMedia,
  StyledScmpLogo,
  Wrapper,
} from "./styles";

export const PostMagazineFooter: FunctionComponent = () => {
  const edition = useEditionValue();
  const homeAsPath = useGetHomeAsPath();
  const { pathname: homePagePathname, query: homePageQuery } = HomePage.route({
    edition,
    slide: "main",
  });

  return (
    <Container>
      <Wrapper>
        <LogoStyleContainer>
          <LogoContainer as={section.postMagazine.urlAlias} pathname="/postmag">
            <LogoPostMagazine />
          </LogoContainer>
          <LogoCaption>Life. Culture. Discovery.</LogoCaption>
        </LogoStyleContainer>
        <StyledPostMagazineSocialMedia />
        <SiteMapContainer>
          <StyledPostMagazineSiteMap />
        </SiteMapContainer>
        <Footer>
          <LogoSCMPContainer
            as={homeAsPath}
            pathname={homePagePathname}
            query={{ ...homePageQuery }}
          >
            <StyledScmpLogo />
          </LogoSCMPContainer>
          <Copyright>
            Copyright © {new Date().getFullYear()} South China Morning Post Publishers Ltd. All
            rights reserved.
          </Copyright>
        </Footer>
      </Wrapper>
    </Container>
  );
};
